import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface StoreSettings {
  store_name: string;
  store_email: string;
  store_phone: string;
  store_address: string;
  currency: string;
  free_shipping_threshold: number;
  default_shipping_rate: number;
  meta_title: string;
  meta_description: string;
}

const DEFAULT_SETTINGS: StoreSettings = {
  store_name: "Gaonova",
  store_email: "",
  store_phone: "",
  store_address: "",
  currency: "INR",
  free_shipping_threshold: 999,
  default_shipping_rate: 99,
  meta_title: "",
  meta_description: "",
};

export function useStoreSettings() {
  return useQuery({
    queryKey: ["store_settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("store_settings")
        .select("*");
      
      if (error) throw error;
      
      const settingsMap = data.reduce((acc: Record<string, any>, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {});

      return {
        store_name: settingsMap.store_name || DEFAULT_SETTINGS.store_name,
        store_email: settingsMap.store_email || DEFAULT_SETTINGS.store_email,
        store_phone: settingsMap.store_phone || DEFAULT_SETTINGS.store_phone,
        store_address: settingsMap.store_address || DEFAULT_SETTINGS.store_address,
        currency: settingsMap.currency || DEFAULT_SETTINGS.currency,
        free_shipping_threshold: Number(settingsMap.free_shipping_threshold) || DEFAULT_SETTINGS.free_shipping_threshold,
        default_shipping_rate: Number(settingsMap.default_shipping_rate) || DEFAULT_SETTINGS.default_shipping_rate,
        meta_title: settingsMap.meta_title || DEFAULT_SETTINGS.meta_title,
        meta_description: settingsMap.meta_description || DEFAULT_SETTINGS.meta_description,
      } as StoreSettings;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
